import React, { Component } from "react";
import { Button, Container } from "reactstrap";
import { notification, Divider } from "antd";
import { Row, Col } from "reactstrap";
import "./style.css";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { NotificationTwoTone, LoadingOutlined } from "@ant-design/icons";
import IntroVidBanner from "../../Images/introVidBanner.jpg";

class HomeCards extends Component {
  state = {
    mainIntroVidEnded: false,
    loading: true,
    initialClick: true,
    counter: 77,
  };

  componentDidMount() {
    this.openIntorNotification();
    const listener = (event) => {
      if (event.code === "F10" || event.code === "F10") {
        this.setState({ mainIntroVidEnded: true });
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }

  openIntorNotification = () => {
    let placement = "bottomRight";
    notification.open({
      message: `Attention!!`,
      description: (
        <div id="openIntorNotification">
          <p>
            You are requested to watch complete Introduction video inorder to
            apply at W4WORK.
          </p>
          <p>Once Applied, WORK HR will get back to you as soon as posible.</p>
          <h6>All The Best</h6>
        </div>
      ),
      duration: 6,
      icon: <NotificationTwoTone twoToneColor="#dc3545" />,
      placement,
    });
  };

  render() {
    const { loading, mainIntroVidEnded, initialClick } = this.state;

    return (
      <div className="careersPage">
        <Divider>
          {loading && initialClick ? (
            <h1>WELCOME</h1>
          ) : !loading ? (
            <h1>Why WORK?</h1>
          ) : loading ? (
            <h1>Loading..</h1>
          ) : null}
        </Divider>

        <Container>
          {!loading && mainIntroVidEnded === false ? (
            <h3>
              Video ends in : {this.state.counter} seconds {"  "}
              <LoadingOutlined />
            </h3>
          ) : null}
          <ReactPlayer
            playing={loading}
            muted={false}
            light={IntroVidBanner}
            width="100%"
            controls={loading}
            className="introVideo "
            onReady={() => {
              this.setState({
                loading: false,
                initialClick: false,
              });
            }}
            onBuffer={() => {
              this.setState({
                loading: true,
              });
            }}
            onBufferEnd={() => {
              this.setState({
                loading: false,
              });
            }}
            onEnded={() =>
              this.setState({
                mainIntroVidEnded: true,
              })
            }
            onProgress={() => {
              if (this.state.counter > 0) {
                setTimeout(
                  this.setState({ counter: this.state.counter - 1 }),
                  1000
                );
              }
            }}
            url="https://firebasestorage.googleapis.com/v0/b/work-dc722.appspot.com/o/Videos%2FSalman%20final.mp4?alt=media&token=003902c2-c4eb-4be1-a979-b62d51d0929a"
          />
          <Row className="tc" gutter={[8, 8]} xs="1" sm="1" md="3">
            <Col>
              <Button
                className="applyButtonMainScreen "
                href="http://w4work.com/"
                target="blank"
              >
                Website
              </Button>
            </Col>
            <Col className="">
              <Link to={"/careers/jobs"}>
                <Button className="applyButtonMainScreen heartbeat">
                  {mainIntroVidEnded === false
                    ? "Skip Video & Apply"
                    : "Apply Now"}
                </Button>
              </Link>
            </Col>

            <Col>
              <Link to="/login">
                <Button className="applyButtonMainScreen ">
                  View Application Status
                </Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default HomeCards;
